import ImageSB, { ImageSBProps } from '@/components/atoms/image/ImageSB';
import LinkButtonSB, {
  LinkButtonSBProps,
} from '@/components/atoms/linkButton/LinkSB';
import RichTextFieldSB, {
  RichTextFieldSBProps,
} from '@/components/atoms/richTextField/RichTextFieldSB';
import { BlockComponentModel } from '@/components/cms/types/blok-component';

import { PopupBanner } from './PopupBanner';

export type PopupBannerStrapiProps = {
  banner: {
    image?: ImageSBProps;
    title: string;
    description: RichTextFieldSBProps;
    cta?: LinkButtonSBProps;
  };
};

export const PopupBannerStrapi = ({
  block,
}: BlockComponentModel<PopupBannerStrapiProps>) => {
  const {
    banner: { image, cta, description, title },
  } = block;
  return (
    <PopupBanner
      image={
        !!image && (
          <ImageSB block={image} inner={{ classNames: { image: 'h-6 w-6' } }} />
        )
      }
      title={title}
      cta={
        !!cta && (
          <LinkButtonSB
            block={cta}
            inner={{ classNames: { root: 'shrink-0' } }}
          />
        )
      }
      description={
        <RichTextFieldSB
          block={description}
          classNames={{
            paragraph: 'text-body-l text-neutral-N80',
          }}
        />
      }
    />
  );
};
